import { type RefObject, useEffect } from "react";

import type { Game } from "src/api";
import { useCamera } from "src/client/human/contexts/camera";

import { BoardViewport } from "../BoardViewport";

export function useBoardViewport(
  host: RefObject<HTMLElement | null>,
  background: string,
  game: Game
) {
  const [cameraCtx] = useCamera();

  useEffect(() => {
    if (!host.current) return;
    const viewport = new BoardViewport(
      host.current,
      background,
      game
    ).setCameraContext(cameraCtx);
    return () => viewport.dispose();
  }, [host, background, cameraCtx, game]);
}
